module.exports = __webpack_public_path__ + "static/media/anurag.c02a017d.jpeg";